"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "type": "string",
  "enum": ["tg0", "tg1", "tg2", "tg3"],
  "enumNames": ["TG0: Ingen symptomer", "TG1: Svake symptomer", "TG2: Vesentlige symptomer", "TG3: Kraftige eller alvorlige symptomer"],
  "default": "tg0"
};
exports.default = _default;
module.exports = exports.default;